import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { STATUS_LABELS, STATUS_COLORS, PETITION_TYPES } from "@/lib/constants";
import { formatDate } from "@/lib/constants";
import { ArrowRight } from "lucide-react";

const daysSince = (d) => Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 86400000));

export const PendingPetitionsWidget = ({ title, range = {} }) => {
  const [items, setItems] = useState(null);
  const [villages, setVillages] = useState({});

  useEffect(() => {
    Promise.all([
      api.get("/petitions", { params: { status: "beklemede" } }),
      api.get("/petitions", { params: { status: "islemde" } }),
    ]).then(([a, b]) => setItems([...a.data, ...b.data].sort((x, y) => (x.date || "").localeCompare(y.date || ""))));
    api.get("/villages").then((r) => setVillages(Object.fromEntries(r.data.map((v) => [v.id, v.name]))));
  }, []);

  const inRange = (p) => (!range.date_from || (p.date || "") >= range.date_from) && (!range.date_to || ((p.date || "").slice(0, 10) <= range.date_to && !!p.date));
  const shown = items ? items.filter(inRange) : null;
  return (
    <Card className="p-6 border border-slate-200 shadow-sm mt-6" data-testid="pending-petitions-card">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-4">
        <div>
          {title}
          <p className="text-xs text-slate-500 mt-1">Beklemede ve işlemde olan dilekçeler — en eski tarihli en üstte</p>
        </div>
        <Link to="/dilekceler" className="text-sm text-emerald-700 hover:text-emerald-800 inline-flex items-center gap-1"
              data-testid="pending-petitions-all-link">
          Tüm dilekçeler <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      {shown && shown.length === 0 && (
        <div className="text-sm text-slate-500 py-8 text-center" data-testid="pending-petitions-empty">
          {range.date_from || range.date_to ? "Seçilen dönemde sonuçlanmayı bekleyen dilekçe yok." : "Sonuçlanmayı bekleyen dilekçe yok."}
        </div>
      )}
      {shown && shown.length > 0 && (
        <div className="divide-y divide-slate-100" data-testid="pending-petitions-list">
          {shown.map((p) => (
            <div key={p.id} className="py-3 flex flex-wrap items-center gap-x-4 gap-y-1" data-testid={`pending-petition-${p.id}`}>
              <div className="font-mono text-xs text-slate-500 w-24">{formatDate(p.date)}</div>
              <div className="flex-1 min-w-[200px]">
                <div className="text-sm font-medium text-slate-900 truncate">{p.subject}</div>
                <div className="text-xs text-slate-500">
                  {p.applicant_name} · {villages[p.village_id] || "Köy belirtilmemiş"} · {PETITION_TYPES[p.petition_type]}
                </div>
              </div>
              <div className="text-xs text-slate-500 whitespace-nowrap">{daysSince(p.date)} gündür</div>
              <span className={`inline-flex px-2 py-0.5 rounded-full text-xs border ${STATUS_COLORS[p.status]}`}>
                {STATUS_LABELS[p.status]}
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
